export const gridDefinition = {
    offset: {}, colspan: { default: 12 }
}